import {QuantityType} from 'smag-commons/dto/msg';
import {isDefined} from '../../commons/commons';

export interface EnergyBin {
    baseTimestamp: number;
    timestamps: number[]; // sorted
    absorbedPowers: number[]; // corresponding to `timestamps`
    injectedPowers: number[]; // corresponding to `timestamps`
    sharedPowers: number[]; // corresponding to `timestamps`
    absorbedEnergy?: number;
    injectedEnergy?: number;
    sharedEnergy?: number;
}

export function mkHourlyBins(timeframe: number[], data: { [qt in QuantityType]?: number[] }, endTime: number): EnergyBin[] {
    const bins: EnergyBin[] = [];
    timeframe.forEach((t, i) => {
        if ((t % 3600000 === 0) || !bins.length) {
            bins.push({
                baseTimestamp: t - (t % 3600000),
                timestamps: [t],
                absorbedPowers: [extractData(data, QuantityType.ABSORBED_POWER, i)],
                injectedPowers: [extractData(data, QuantityType.INJECTED_POWER, i)],
                sharedPowers: [extractData(data, QuantityType.SHARED_POWER, i)]
            });
        } else {
            const currBin = bins[bins.length - 1];
            currBin.timestamps.push(t);
            currBin.absorbedPowers.push(extractData(data, QuantityType.ABSORBED_POWER, i));
            currBin.injectedPowers.push(extractData(data, QuantityType.INJECTED_POWER, i));
            currBin.sharedPowers.push(extractData(data, QuantityType.SHARED_POWER, i));
        }
    });
    return bins.map((bin, index, _bins) => integrateBin(bin, index, _bins, endTime));
}

function extractData(data: { [qt in QuantityType]?: number[] }, qt: QuantityType, index: number): number {
    const qtData = qt in data ? data[qt][index] : null;
    return isDefined(qtData) ? qtData : 0;
}

function integrateBin(bin: EnergyBin, index: number, bins: EnergyBin[], endTime: number): EnergyBin {
    let absorbedEnergy = 0;
    let injectedEnergy = 0;
    let sharedEnergy = 0;
    bin.timestamps.forEach((t, i) => {
        const nextTimestamp = i < bin.timestamps.length - 1 ? bin.timestamps[i + 1] : (index < bins.length - 1 ? bins[index + 1].timestamps[0] : endTime);
        const dt = (nextTimestamp - t) / 3600000; // in hours
        absorbedEnergy += bin.absorbedPowers[i] * dt;
        injectedEnergy += bin.injectedPowers[i] * dt;
        sharedEnergy += bin.sharedPowers[i] * dt;
    });
    return {
        ...bin,
        absorbedEnergy,
        injectedEnergy,
        sharedEnergy
    };
}
